import { Divider, Select, Space, TimePicker, DatePicker } from "antd";
import 'moment-timezone';
import React, { useEffect, useState } from 'react';
import Loading from "../Loading";
import SessionManager from "../../routes/SessionManager";
import CommonUtils from "../../util/CommonUtils";
import moment from "moment";
import Toastr from 'toastr';
import XMLParser from 'react-xml-parser';
import API from '../../service/SiteKickAPIService';

function HistoricalDataModal(props) {

    let sessionManager = new SessionManager();
    let user = sessionManager.readCookie('user');
    let timezone = user.site_selected.site_iana_timezone;
    let site_selected = user && user.site_selected ? user.site_selected : null;
    let zones = user.zones;
    let [zones_selected, setZonesSelected] = useState([]);
    let [date_range, setDateRange] = useState(null);
    let [time_range, setTimeRange] = useState(null);
    let [recordingMap, setRecordingMap] = useState({});

    let getRecordingPromise = (device_id) => {
        return new Promise((resolve, reject) => {
            CommonUtils.ajax({
                url: API.AXIS_CAMERA.RECORDINGS,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                headers: {
                    user_login: user.user_login,
                    user_token: user.user_token
                },
                data: JSON.stringify({ device_id: device_id }),
                success: function (response) {
                    if (response.status.code === 200) {
                        let recordingsJSON = new XMLParser().parseFromString(response.data);
                        let recordings = recordingsJSON.getElementsByTagName('recording');
                        resolve({ device_id: device_id, recordings: sortRecordings(recordings) });
                    } else {
                        resolve(null);
                    }
                },
                error: function (xhr, status) {
                    resolve(null);
                }
            });
        })
    }

    useEffect(() => {
        let promises = [];
        zones && zones.map((zone) => {
            if (zone.location_device_type === 'axis')
                promises.push(getRecordingPromise(zone.device_id));
            return { label: zone.location_name, value: zone.location_id };
        })

        if (promises.length > 0) {
            Promise.all(promises).then(responses => {
                let rMap = {};
                for (let r of responses) {
                    if (r)
                        rMap[r.device_id] = r.recordings;
                }
                console.log('RMap', rMap);
                setRecordingMap(rMap);
            });
        }
    }, [recordingMap]);

    let sortRecordings = (recording) => {
        if (recording !== undefined && recording && recording.length > 0) {
            if (recording.length > 1)
                recording = recording.sort((a, b) => b.attributes['starttime'] > a.attributes['starttime'] ? -1 : b.attributes['starttime'] < a.attributes['starttime'] ? 1 : 0);
        }
        return recording;
    }

    /**
     * Check if any recording overlaps with the given time range
     * @param {Array} recordings - Array of recordings with starttime and stoptime
     * @param {string|Date} rangeStart - Start of the range (e.g. "2025-08-04T07:00:00Z")
     * @param {string|Date} rangeEnd - End of the range
     * @returns {boolean}
     */
    const hasRecordingInRange = (recordings, rangeStart, rangeEnd) => {
        const rangeStartTime = new Date(rangeStart).getTime();
        const rangeEndTime = new Date(rangeEnd).getTime();

        console.log('recordings', recordings);

        return recordings ? recordings.some(rec => {
            const startTime = new Date(rec.attributes.starttime).getTime();
            const stopTime = rec.stoptime ? new Date(rec.attributes.stoptime).getTime() : new Date().getTime();

            console.log('startTime: ', startTime, ', stopTime: ', stopTime, ', rangeStartTime: ', rangeStartTime, ', rangeEndTime', rangeEndTime);
            let found = ((startTime >= rangeStartTime && startTime <= rangeEndTime) ||
                // Case 2: Recording ends within the range
                (stopTime >= rangeStartTime && stopTime <= rangeEndTime) ||
                // Case 3: Recording starts before and ends after the range (fully wraps it)
                (startTime <= rangeStartTime && stopTime >= rangeEndTime)
            );
            return found;
        }) : false;
    }

    let historicalAxisRequest = async (zone, extraAtts = {}) => {
        return new Promise(async function (resolve, reject) {

            let data = {
                device_id: zone.device_id,
                customer_id: zone.customer_id,
                location_id: zone.location_id,
                site_id: zone.site_id,
                user_login: user.user_login,
                user_token: user.user_token,
                timestamp: moment.utc().format('YYYY-MM-DD HH:mm:ss'),

                timestamp_to_tag: extraAtts.start_ts,
                sec_timestamp: extraAtts.start_ts,
                sec_timestamp_end: parseInt(extraAtts.end_ts - extraAtts.start_ts),
                start_ts: extraAtts.starttime, //2023-03-05T09:45:09Z
                end_ts: extraAtts.stoptime,
                vid_duration_max_allowed: 0
            }

            console.log("Axis Historical Data Request: ", data);

            CommonUtils.ajax(
                {
                    url: API.AXIS_CAMERA.SAVE_VIDEO,
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    headers: {
                        user_login: user.user_login,
                        user_token: user.user_token
                    },
                    data: JSON.stringify(data)
                }
            ).then(
                (res) => {
                    if (res.status && res.status.code === 200) {
                        resolve(res.data);
                    } else {
                        reject(null);
                    }
                },
                (error) => {
                    reject(null);
                }
            );

        });
    }

    let historicalDataRequest = async (zone, extraAtts = {}) => {
        return new Promise(async function (resolve, reject) {

            let device_iotname = null;
            if (zone.location_device_type === 'uniview') {
                let deviceObj = await CommonUtils.getDevice(zone.device_id, user);
                device_iotname = deviceObj ? deviceObj.device_iotname : null;
            }

            var data = {
                user_login: user.user_login,
                user_token: user.user_token,
                form_input: {
                    operation: "save-historic-clip",
                    site_id: zone.site_id,
                    customer_id: zone.customer_id,
                    location_id: zone.location_id,
                    device_id: zone.device_id,
                    device_iotname: device_iotname,
                    device_type: zone.location_device_type,
                    use_all_images: false,
                    ...extraAtts
                }
            };

            console.log("Historical Data Request: ", data);

            CommonUtils.ajax(
                {
                    url: API.CAMERA.LIVE_FEED,
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify(data)
                }
            ).then(
                (res) => {
                    if (res.status) {
                        if (res.status.code === 200)
                            resolve(res.data);
                        else
                            reject(null);
                    } else {
                        reject(null);
                    }
                },
                (error) => {
                    reject(null);
                }
            );
        }).catch((err) => { });
    }

    const submitHistoricalDataRequest = () => {

        if (!site_selected || !zones_selected || zones_selected.length === 0 || !date_range || !time_range) {
            Toastr.info('Please select zones, start date, end date and time range.');
            return;
        }

        let start_dt = date_range[0].format('YYYY-MM-DD');
        let end_dt = date_range[1].format('YYYY-MM-DD');
        let start_time = time_range[0].format('HH:mm:ss');
        let end_time = time_range[1].format('HH:mm:ss');
        let _zones = zones.filter(zone => zones_selected.includes(zone.location_id));
        let promises = [];

        let startTS = moment.tz(start_dt + ' ' + start_time, timezone).unix();
        let endTS = moment.tz(end_dt + ' ' + end_time, timezone).unix();
        let useAllImages = (endTS - startTS) <= 180;

        for (let z of _zones) {
            let isAxisCam = z.location_device_type && z.location_device_type === 'axis';
            let extraAtts = {
                start_ts: startTS,
                end_ts: endTS,
                use_all_images: useAllImages,
                starttime: moment.tz(start_dt + ' ' + start_time, timezone).format('YYYY-MM-DDTHH:mm:ssZ'),
                stoptime: moment.tz(end_dt + ' ' + end_time, timezone).format('YYYY-MM-DDTHH:mm:ssZ'),
            };
            promises.push(isAxisCam ? historicalAxisRequest(z, extraAtts) : historicalDataRequest(z, extraAtts));
        };

        Promise.all(promises).then((res) => {
            if (res && res.length > 0) {
                setZonesSelected([]);
                setDateRange(null);
                setTimeRange(null);
                console.log('res', res);
                Toastr.success('Historical data request submitted successfully. Check the videos section for videos.');
            }
            props.handle(false);
        }).catch((err) => {
            Toastr.error("Error submitting historical data request");
            console.error("Error submitting historical data request: ", err);
        });

    }

    const disabledDate = (current) => {
        return current && current > moment().endOf('day');
    };

    const filterZonesBasedOnDVRStatus = () => {
        const filteredZones = [];

        let start_dt = date_range[0].format('YYYY-MM-DD');
        let end_dt = date_range[1].format('YYYY-MM-DD');
        let start_time = time_range[0].format('HH:mm:ss');
        let end_time = time_range[1].format('HH:mm:ss');

        let startDateTime = moment.tz(start_dt + ' ' + start_time, timezone).format('YYYY-MM-DDTHH:mm:ssZ');
        let endDateTime = moment.tz(end_dt + ' ' + end_time, timezone).format('YYYY-MM-DDTHH:mm:ssZ');

        for (let z of zones) {
            if (z.location_device_type && z.location_device_type === 'axis') {
                let isValid = hasRecordingInRange(recordingMap[z.device_id], startDateTime, endDateTime)
                if (isValid)
                    filteredZones.push({ label: z.location_name, value: z.location_id });
                else {
                    filteredZones.push({ label: z.location_name, value: z.location_id, disabled: true });
                    console.log('No recording found ...' + z.location_name);
                }
            } else {
                filteredZones.push({ label: z.location_name, value: z.location_id });
            }
        }

        console.log('filterZonesBasedOnDVRStatus', filteredZones);
        return filteredZones;
    }

    const getZoneSelector = () => {
        if (!(date_range && time_range))
            return;
        let zone_map = filterZonesBasedOnDVRStatus();
        return (date_range && time_range) && <tr>
            <td className="text-left"><label className="text-primary">Zones:</label></td>
            <td><Select
                mode="multiple"
                value={zones_selected}
                style={{ width: '200px', fontSize: '13px' }}
                onChange={(v) => {
                    setZonesSelected(v)
                }}
                options={zone_map}
                size="small"
                allowClear={true}
                showSearch={true}
                filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                notFoundContent="No zones found"
                className="form-control form-control-sm"
                autoClearSearchValue={true}
                showArrow={true}
                dropdownMatchSelectWidth={false}
                placeholder="Choose Zones"
                dropdownRender={(menu) => (
                    <>
                        {menu}
                        <Divider style={{ margin: '8px 0' }} />
                        <Space style={{ padding: '0px 4px' }}>
                            <button className="btn btn-sm btn-success" onClick={() => setZonesSelected(zone_map.filter(z => !z.disabled).map(zone => zone.value))}>
                                All Zones
                            </button>
                        </Space>
                    </>
                )}
            />
                <br /><small><i className="fa fa-info-circle text-app"></i> Zones with no recordings in above date range are shown as disabled.</small>
            </td>
        </tr>;
    }

    return (
        <React.Fragment>
            {!zones ? <div className="p-5"><Loading>Loading ...</Loading></div> :
                zones.length === 0 ? <center className="p-5">No zones found.</center> :
                    <>
                        <table width="100%">
                            <tbody>
                                <tr>
                                    <td className="text-left"><label className="text-primary">Site:</label></td>
                                    <td>{user && user.site_selected && user.site_selected.site_name}</td>
                                </tr>
                                <tr>
                                    <td className="text-left"><label className="text-primary">Date:</label></td>
                                    <td className="text-left">
                                        <DatePicker.RangePicker value={date_range} disabledDate={disabledDate} onChange={(v) => setDateRange(v)} format={'YYYY-MM-DD'}></DatePicker.RangePicker>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="text-left"><label className="text-primary">Time Range:</label></td>
                                    <td className="text-left">
                                        <TimePicker.RangePicker format={'HH:mm'} value={time_range} onChange={(v) => setTimeRange(v)} placeholder={['Start Time', 'End Time']}></TimePicker.RangePicker>
                                    </td>
                                </tr>
                                {
                                    getZoneSelector()
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan="2" className="text-right py-3">
                                        <button className="btn btn-default btn-sm" onClick={() => {
                                            setZonesSelected([]);
                                            setDateRange(null);
                                            setTimeRange(null);
                                            if (props.handle) {
                                                props.handle(false);
                                            }
                                        }}>Cancel</button>
                                        <button disabled={!site_selected || !zones_selected || zones_selected.length === 0 || !date_range || !time_range} className="btn btn-primary btn-sm ml-2" onClick={() => submitHistoricalDataRequest()}>Submit</button>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </>
            }
        </React.Fragment >
    );
}

export default HistoricalDataModal;